import { React, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";

import Button from "../../components/Button/Button";
import EditCardProfile from "../../components/Card/EditCardProfile";
import CoverImage from "../../common/images-new/cover-image.png"
import EditCardStatus from "../../components/Card/EditCardStatus";
import Map from "../../components/Map";
import CardBlue from "../../components/Card/CardBlue";
import hmenu_user from "../../common/images/photo.jpg";
import ValueComp from "../Footer/ValueComp";
import EditCardPost from "../../components/Card/EditCardPost";
// import ButtonBlue from "../../components/Button/ButtonBlue";
import WidgetIcon from '../../common/images-new/widget-icon.svg'
import CoverIcon from '../../common/images-new/cover-icon.svg'

import PageWrapper from '../PageWrapper';
import ColorPopover from "./ColorPopover";
import { MdLightMode, MdDarkMode, MdImage, MdWidgets } from "react-icons/md"
import axios from "axios";
import { apiMainUrl, apiUrl, serverUrl } from "../../components/Helpers/Config";
import { getUserTheme, setUserCover } from "../../redux/actions/auth";
import { staticFiles } from "../../components/Helpers/Static";
import { Card } from "../Theme";
import Swal from "sweetalert2";
import EditMap from "../../components/Map/EditMap";
import EditValueComp from "../Footer/EditValueComp";
import ModalWidget from "../../components/Modal/ModalWidget";
import ModalEditCover from "../../components/Modal/ModalEditCover";
import { tokenAuthorize } from "../../components/Helpers/Common";
import ModalTheme from "../../components/Modal/ModalTheme";
import ButtonCommon from '../../components/Button/ButtonCommon';

const DEFAULT_COVER = staticFiles.coverDefault;

const EditState = (props) => {
    const dispatch = useDispatch()
    let history = useHistory()

    const userProfile = useSelector(state => state.auth.user)
    const profile = {
        name: userProfile ? userProfile.fullname : '',
        email: userProfile ? userProfile.email : '',
        programme: userProfile ? userProfile.programme : '',
        photo: userProfile ? userProfile.photo : hmenu_user,
    }

    const [coverImage, setCoverImage] = useState(userProfile.cover);
    const [coverImageFile, setCoverImageFile] = useState(null);
    const coverImageRef = useRef();

    const userTheme = useSelector(state => state.auth.theme)
    const [theme, setTheme] = useState('light')
    const [showMap, setShowMap] = useState(true)
    const [showModalWidget, setShowModalWidget] = useState(false)
    const [widgetList, setWidgetList] = useState([])

    const [isOpenModal, setisOpenModal] = useState(false);
    const [editCoverImage, seteditCoverImage] = useState("");
    const [compentencyStatus, setcompentencyStatus] = useState(false);
    const [themeModal, setThemeModal] = useState(false);
    const [themeId, setThemeId] = useState(-1);

    // const [showColorPopover, setShowColorPopover] = useState(false)    
    const routeChange = path => {
        history.push(path)
    }

    useEffect(() => {
        if (coverImageFile) {
            const objectURL = URL.createObjectURL(coverImageFile);
            setCoverImage(objectURL);
            return () => URL.revokeObjectURL(objectURL);
        }
    }, [coverImageFile]);

    const handleCoverImageChange = (e) => {
        const fileObj = e.target.files[0];

        if (!fileObj) return;
        setCoverImageFile(fileObj);
    }

    useEffect(() => {
        dispatch(getUserTheme())
    }, [])

    useEffect(() => {
        setcompentencyStatus(props.location?.state?.competency_status);
    }, [props.location?.state?.competency_status])

    useEffect(() => {
        if (userTheme && userTheme.length > 0) {
            // let filteredTheme = userThemes.filter((item) => item.key === 'theme')
            // todo: filter based on user id
            setTheme(userTheme)
            // setTheme(filteredTheme[0].value)
        }
    }, [userTheme])

    const changeTheme = () => {
        // if (theme === "light") {
        //     setTheme('dark')
        // } else {
        //     setTheme('light')
        // }
        setThemeModal(true)
    }

    const saveChanges = (mode) => {
        // save theme
        let profileData = { "profile_id": userProfile?.learner_profile_id }
        if (themeId >= 0) {
            axios.put(serverUrl.putSystemTheme + themeId,
                profileData
                // { 'value': mode }
            ).then(resp => {
                // dispatch(getUserTheme())

            }).catch((err) => {
                tokenAuthorize(err?.response?.status);
                console.log(err)
            })
        }
        Swal.fire({
            icon: "success",
            title: "Success",
            text: "Changes has been saved",
        });

        // save cover image

        let dataImage = {
            file: editCoverImage
        }
        if (editCoverImage != "") {
            axios.post(serverUrl.ProfileCover + "?profile_id=" + userProfile?.learner_profile_id, dataImage
                // { headers: { 'Content-Type': 'multipart/form-data' } }
            ).then(resp => {
                if (resp.status === 200) {
                    dispatch(setUserCover(resp.data.photo))
                    setisOpenModal(false)
                }
            }).catch(err => {
                tokenAuthorize(err?.response?.status);
                console.log(err)
                setisOpenModal(false)
            });
        }

        let status = {
            "competency_status": compentencyStatus
        }

        putUserCompetencies(status, userProfile?.guid);

        history.goBack()
    }


    const putUserCompetencies = (data, Id) => {
        axios.put(serverUrl.ActionCompentencyStatus + Id,
            data
        ).then(resp => {
            if (resp.status === 200) {

            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err)
        });
    }

    const handleCancel = () => {
        Swal.fire({
            title: "Leave page?",
            heightAuto: false,
            text: "Changes you made may not be saved.",
            icon: "warning",
            showCancelButton: false,
            showDenyButton: true,
            confirmButtonText: "Confirm",
            denyButtonText: "Cancel",
            confirmButtonColor: "#3085d6",
            denyButtonColor: "#c1c1c1",
        }).then((result) => {
            if (result.isConfirmed) {
                history.goBack()
            }
        });
    };

    return (

        <PageWrapper>
            {/* <img className="object-none h-32 md:h-full w-full object-cover" style={{backgroundColor: '#D2D1CD'}} src={CoverImage} alt="cover"></img> */}
            <div className="h-40 md:h-56 lg:h-68 xl:h-72 w-full object-contain overflow-hidden">
                <input
                    className="hidden"
                    ref={coverImageRef}
                    type="file"
                    accept="image/gif, image/jpeg, image/jpg, image/png"
                    onChange={handleCoverImageChange}
                />
                {editCoverImage != "" ?
                    <img className="w-full h-288px objectfit-cover bgcolor-img" src={editCoverImage} alt="cover"></img> : <>
                        {(coverImage && (coverImage.length > 0))
                            ? <img className="w-full h-288px objectfit-cover bgcolor-img" src={coverImage} alt="cover"></img>
                            : <img className="w-full h-288px objectfit-cover bgcolor-img" src={DEFAULT_COVER} alt="cover"></img>
                        }</>}
            </div>

            <div className="flex flex-col md:flex-row relative">
                <div className="flex flex-col items-center mx-5 md:ml-4 xl:ml-24 xl:mr-9 ">
                    <EditCardProfile
                        profilePhoto={profile.photo}
                        username={profile.name}
                        email={profile.email}
                    />
                    {/* {
                        widgetList.map((widget, index) => (
                            <div className="hidden md:block flex flex-col md:mt-40 lg:mt-5 mb-16 ">                        
                                <EditMap />
                            </div>
                        ))
                    } */}
                    <div className="hidden md:block flex flex-col md:mt-40 lg:mt-5 mb-16 ">
                        <EditMap />
                    </div>


                </div>

                <div className="flex flex-col md:pr-4 lg:pr-0 xl:mr-24 md:w-7/12 lg:w-8/12 xl:w-full relative">
                    <EditCardStatus />

                    {/* Showcase Nav      */}
                    <div className="flex flex-row items-center space-x-2 xl:space-x-5 relative ">
                        <div className="mt-2 w-36 bg-gray-200 h-6 rounded-md"></div>
                        <div className="mt-2 w-36 bg-gray-200 h-6 rounded-md"></div>
                        <div className="mt-2 w-36 bg-gray-200 h-6 rounded-md"></div>
                        <div className="mt-2 w-36 bg-gray-200 h-6 rounded-md"></div>
                        <div className="mt-2 w-10 bg-gray-200 h-10 rounded-md lg:absolute right-0"></div>

                    </div>


                    {/* Showcase Body */}
                    <div className="mx-3 md:mx-0 mt-3 md:mt-0">
                        <div className="mt-2 w-full bg-gray-200 h-12 rounded-md"></div>
                    </div>
                    <div className="flex flex-row relative mx-3 md:mx-0 my-7 md:my-0">
                        <div className="mt-2 w-36 bg-gray-200 h-12 rounded-md"></div>
                        <div className="absolute top-2 right-0">
                            <div className="mt-2 w-36 bg-gray-200 h-8 rounded-md"></div>
                        </div>
                    </div>

                    <EditCardPost />
                    <EditCardPost />

                </div>

                <ModalEditCover
                    showModalEditCover={isOpenModal}
                    setshowModalEditCover={setisOpenModal}
                    editCover={true}
                    editBanner={false}
                    seteditCoverImage={seteditCoverImage}
                />

                <ModalTheme
                    showModalEditCover={themeModal}
                    setshowModalEditCover={setThemeModal}
                    setThemeId={setThemeId}
                />


                {/* Edit Layout Mode Bar */}

                <Card className="flex flex-col md:flex-row w-screen md:px-5 lg:px-10 xl:px-28 z-40 absolute top-64 right-0">
                    <p className="flex md:items-center justify-center mt-2 md:mt-0 font-semibold ">You are in edit layout mode</p>
                    <div className="flex flex-col md:flex-row justify-center py-5 space-x-1 md:space-x-5  mx-2 md:mx-0 md:ml-5 lg:ml-8 xl:ml-56">
                        <div className="flex flex-row mb-3 md:mb-0 space-x-1 md:space-x-5 justify-between ">
                            {/* <Button title="Add widget" onClick={() => setShowModalWidget(true)} >
                                <MdWidgets className="w-7 h-7" />
                            </Button> */}
                            {/* <Button title="Edit cover" onClick={() => { coverImageRef.current.click() }}>
                                <MdImage className="w-7 h-7" />
                            </Button> */}
                            <Button style='h-12' title="Edit cover" onClick={() => { setisOpenModal(true) }}>
                                <MdImage className="w-7 h-7" />
                            </Button>
                            <Button
                                className="flex flex-row bg-white hover:bg-gray-200 rounded-lg border-2 px-3 py-3 t
                                            items-center w-flex filter drop-shadow-sm cursor-pointer space-x-2"
                                onClick={changeTheme}
                                title={'Change theme'}
                                style='h-12'
                            >
                                {theme === 'light' ?
                                    <MdLightMode className="w-7 h-7" />
                                    :
                                    <MdDarkMode className="w-7 h-7" />
                                }
                            </Button>


                            {/* <div className="mr-2 rounded-full w-6 h-6 bg-blue"></div>
                            <div className="absolute">
                                <ColorPopover show={showColorPopover} handleClose={() => setShowColorPopover(false)}/>
                            </div>
                            
                            <button 
                                className="flex flex-row bg-white hover:bg-gray-200 rounded-lg border-2 px-3 py-3 t
                                            items-center justify-center w-flex filter drop-shadow-sm cursor-pointer" 
                                onClick={() => setShowColorPopover(true)}
                                
                            >
                                <div className="mr-2 rounded-full w-6 h-6 bg-blue"></div>
                                <p className="text-gray font-semibold text-xs lg:text-sm">Change color</p>
                            </button>   */}
                        </div>
                        <ButtonCommon className='h-12 px-10 py-3' bgColor="bg-blue-500" color="text-white" title="Save changes" onClick={() => saveChanges(theme)} />
                        <Button style='h-12' title="Cancel" onClick={() => handleCancel()} />
                    </div>
                </Card>


            </div>

            <EditValueComp
                compentencyStatus={compentencyStatus}
                setcompentencyStatus={setcompentencyStatus}
                isHide={true}
            />

            <div className="block md:hidden flex flex-col items-center bg-white pb-5">
                <EditMap />
            </div>
            <ModalWidget
                show={showModalWidget}
                setShow={setShowModalWidget}
            />
        </PageWrapper>
    )
}

export default EditState